module.exports = __webpack_public_path__ + "zarustajici-nehty_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/zarustajici-nehty_5_after.jpg
// module id = 1045
// module chunks = 0